<template>
	<Card cinza class="categoria">
		<div class="categoria__cabecalho">
			<slot name="cabecalho" />
		</div>

		<Card borda>
			<ul class="categoria__itens">
                <slot name="conteudo" />
			</ul>
		</Card>
	</Card>
</template>

<script>
import Card from '../shared/Card.vue'

export default {
	components: {
		Card,
	},
}
</script>

<style scoped>

ul,
li {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.categoria {
	margin-bottom: 1rem;
}



.categoria__cabecalho {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.categoria__nome {
	font-size: 1rem;
	color: #6d6767;
}

.categoria__detalhes {
	color: #6d6767;
}

.categoria__botoes-nav {
	display: flex;
	gap: 1rem;
	color: #6d6767;
}

.categoria__checkbox {
	margin: 0;
}

.categoria__itens {
	max-height: 15rem;
	overflow: auto;
	padding: 0.5rem;
	margin-top: -1rem;
	margin-bottom: -1rem;
}

.categorias__etapas {
	color: #6d6767;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.categoria__botoes {
	display: flex;
	align-items: center;
	gap: 1rem;
}

::-webkit-scrollbar {
	height: 0.5em;
	width: 0.5em;
}

::-webkit-scrollbar-track {
	background: #d9d9d9;
	border-radius: 100vw;
	margin-block: 1rem;
}

::-webkit-scrollbar-thumb {
	background: #6d6767;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--v-primary-base);
}

@media (max-width: 600px) {
	.categoria__itens {
		max-height: 100%;
		overflow: hidden;
		padding: 0rem;
		margin-top: 0rem;
		margin-bottom: 0rem;
	}
}
</style>